export default "__VITE_ASSET__CVUG73xj__"